import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {CacheService} from '../services/cache.service';
import {tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    constructor(private cacheService: CacheService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method !== 'GET') {
            this.cacheService.invalidateCache();
            return next.handle(req);
        }
        if (req.url == environment.apiUrl + 'current') {
           this.cacheService.invalidateCache();
           return next.handle(req);
        }

        const cached = this.cacheService.retrieve(req.url);
        if (cached) {
            return of(cached);
        }

        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.cacheService.store(req.url, event);
                }
            })
        );
    }
}
